import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as componentTypes from "../../../constants/componentTypes";
import * as navigationActions from "../../../actions/navigationActions";
import * as modelHelper from "../../../helpers/modelHelper";

import Modal from "../generic/Modal";
import CancelButton from "../generic/CancelButton";

import imgLoader from "../../../resources/img/search-loader.gif";

class SearchingModal extends Component {
    handleCloseModalClick = () => {
        if (this.props.params.onCancel !== null) {
            this.props.dispatchAction(this.props.params.onCancel);
        }

        this.props.dispatchCloseModalAction();
    };

    getModalMessage = () => {
        if (this.props.params.message !== null) {
            return this.props.params.message;
        }

        return <Translate value="welcome.loading" />;
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="font-size-0_75em col-12">{this.getModalMessage()}...</div>
                <div className="text-center col-12">
                    <img alt="loading" src={imgLoader} />
                </div>
            </React.Fragment>,
            "flex flex-wrap"
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.tabId}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="general.searching" />)}
                content={this.getContent()}
                footer={modelHelper.buildModalSection(<CancelButton onClick={this.handleCloseModalClick} />)}
            />
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.SEARCHING_MODAL));
        },
        dispatchAction: (action) => {
            dispatch(action);
        }
    };
};

export default SearchingModal = connect(mapStoreToProps, mapDispatchToProps)(SearchingModal);
